import { useEditor } from "../EditorContext"
import LabelForm from "./LabelForm"
import ConfirmationModal from "../../../common/ConfirmationModal"


function Label ({groupId, label, formStructure}) {

  const {
    removeElement,
    editingElement,
    setEditingElement,
    findElementPath,
    moveElement
  } = useEditor()
  
  const isEditing = editingElement === label.id

  const path = findElementPath(formStructure, label.id)
  // Если глубина пути 4, значит лейбл находится внутри Group. Если глубина - 6, лейбл находится внутри Layout
  const parentElementType = path.length === 4 ? 'group' : 'layout'

  let modalId = 'confirmLabelDeleteModal_' + label.id

  return (
    <>

      <ConfirmationModal
        modalId={modalId}
        headerText="Текстовый комментарий"
        messageText={[
          "Вы уверены, что хотите удалить текст?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => removeElement(formStructure, label.id)}
        danger
      />

      {parentElementType === 'group' ?
        <>
          <fieldset className="border p-4 mt-3">
            <legend  className="float-none w-auto px-2 text-secondary fs-6">
              {/*
              <button
                className="btn editor-button ms-1 me-0 mt-2"
                onClick={() => removeElement(formStructure, label.id)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="red" className="bi bi-x-square" viewBox="0 0 16 16">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
              */}

              <button className="btn editor-button mx-1 mt-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-menu-button-wide" viewBox="0 0 16 16">
                  <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
                  <path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
                </svg>
              </button>
              <ul className="dropdown-menu">
                <button 
                  className="dropdown-item lk-menu-dropdown" 
                  onClick={() => moveElement(formStructure, groupId, label.id, 'up')}
                >
                  переместить вверх</button>
                <button 
                  className="dropdown-item lk-menu-dropdown" 
                  onClick={() => moveElement(formStructure, groupId, label.id, 'down')}
                >
                  переместить вниз
                </button>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target={'#' + modalId}>Удалить текст</button>
              </ul>
              {isEditing ?
                <>
                  <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(undefined)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-check-square" viewBox="0 0 16 16">
                      <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                      <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                    </svg>
                  </button>
                </>
              :
                <>
                  <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(label.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                      <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                  </button>
                </>
              }
              <span className="ms-2">Текстовый блок</span>
            </legend>
            <div className="row mb-3">
              <div className="col">
                <h6 className="">{label.text}</h6>
              </div>
            </div>
            {isEditing ?        
              <LabelForm
                label={label}
                formStructure={formStructure}
                parentElementType={parentElementType}
              />
            :
              <></>
            }  
          </fieldset>
  
        </>
      :



        <div>
          <div className="card-header p-0">
            <div className="row px-3">
              <div className="col-8 d-flex align-items-center">
                <small className="fw-semibold fsvok2-text text-truncate">лейбл</small>
              </div>
              <div className="col-4 d-flex align-items-center">
                {isEditing ?
                  <>
                    <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(undefined)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                      </svg>
                    </button>
                  </>
                :
                  <>
                    <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(label.id)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                      </svg>
                    </button>
                  </>
                }
                <button
                  className="btn editor-button ms-1 me-0 mt-2"
                  onClick={() => removeElement(formStructure, label.id)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                  </svg>
                </button>
              </div>  
            </div>
          </div>  
          <div className="card-body overflow-hidden" style={{'maxHeight': 110}}>
            <h6 className="">{label.text}</h6>
          </div>            
        </div>

      }
    </>
  )
}

export default Label